import { auth } from './UserAuthService';
import { config } from '../config/config';
import { refreshTokenNow } from './ApiConfig';

class TokenRefreshService {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  start(): void {
    if (this.intervalId) return; // already running

    const intervalMs = config.api.tokenRefreshInterval * 1000;
    this.intervalId = setInterval(() => this.refresh(), intervalMs);
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private async refresh(): Promise<void> {
    if (!auth.loggedIn() || !auth.getRefreshToken()) {
      this.stop();
      return;
    }

    try {
      await refreshTokenNow();
    } catch (error) {
      console.error('Background token refresh failed:', error);
    }
  }
}

const tokenRefreshService = new TokenRefreshService();
export default tokenRefreshService;
